import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden pt-20 pb-16 px-6 lg:px-12" data-id="element-94" data-mp="ejwl1drxcj8d">
      {/* Background decorative blobs */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-eucalipto/10 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob" data-id="element-95" data-mp="9l37jlcn0s87"></div>
      <div className="absolute top-40 right-10 w-72 h-72 bg-terracota/10 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000" data-id="element-96" data-mp="129qv5nkuztox"></div>

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-97" data-mp="sbb1pdyd08c9">
        <motion.div className="flex flex-col items-start space-y-8 order-2 lg:order-1" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-98" data-mp="ncq0pcba9kmr">
          <div className="space-y-4" data-id="element-99" data-mp="3j9alrqbghebh">
            <motion.h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-dark leading-tight" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-100" data-mp="3o7c4291259lw">
              Tu espacio para <br data-id="element-101" data-mp="359j8xswoe3z2" />
              <span className="text-eucalipto" data-id="element-102" data-mp="35a2hij0frg0f">sanar y crecer</span>
            </motion.h1>
            <motion.p className="text-lg md:text-xl text-medium max-w-lg leading-relaxed font-light" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-103" data-mp="2qlelycqlb6ah">
              Acompañamiento profesional para transformar tu bienestar emocional
              en un entorno seguro y confidencial.
            </motion.p>
          </div>

          <motion.a href="https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno" target="_blank" rel="noopener noreferrer" className="inline-block bg-terracota text-white px-8 py-4 rounded-full font-medium tracking-wide shadow-neumorph-sm hover:shadow-neumorph transition-all duration-300 hover:-translate-y-1" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-104" data-mp="ibypocqjh226">
            Agendar Sesión
          </motion.a>
        </motion.div>

        <motion.div className="relative order-1 lg:order-2 flex justify-center lg:justify-end" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.3
      }} data-id="element-105" data-mp="21awdua25atgy">
          <div className="relative w-full max-w-md aspect-[4/5] lg:aspect-square" data-id="element-106" data-mp="2fzj2j2dnwxku">
            <div className="absolute inset-0 bg-eucalipto/20 blob-shape transform translate-x-4 translate-y-4" data-id="element-107" data-mp="2kxknjsunf6yy"></div>
            <img src="https://images.unsplash.com/photo-1586105251261-72a756497a11?w=800&q=80" alt="Entorno de consulta acogedor" className="relative z-10 w-full h-full object-cover blob-shape shadow-neumorph" data-id="element-108" data-mp="2p1a4bw530k9f" />
          </div>
        </motion.div>
      </div>
    </section>;
}